import Stepper from "@digipost/dds-stepper-react";
import { FC } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";

import { ReduxState } from "../infrastructure/redux/state";
import { useTranslate } from "../infrastructure/useTranslate";
import { isAlreadyRegistered } from "./domain";
import styles from "./RegisterFlowStepper.module.css";

type StepId =
  | "POWER_OF_ATTOURNEY"
  | "TERMS"
  | "ACCOUNT_DETAILS"
  | "COMPLETE"
  | "MANUAL_ACCOUNT_DETAILS";

type Props = {
  currentStep: StepId;
};

const noop = (): void => {};

const RegisterFlowStepper: FC<Props> = ({ currentStep }) => {
  const translate = useTranslate();
  const location = useLocation();
  const { integrationType, mode } = useSelector(
    (state: ReduxState) => state.app.params,
  );
  const data = useSelector((state: ReduxState) => state.org.data);
  const selectedOrganisationNumber = useSelector(
    (state: ReduxState) => state.org.userInput.selectedOrganisationNumber,
  );

  const selectedOrganisation = data?.registrableOrganisations.find(
    (p) => p.organisationNumber === selectedOrganisationNumber,
  );

  const chosenOrgRegisteredInDigipost =
    selectedOrganisation && isAlreadyRegistered(selectedOrganisation);
  const isManualRegistration = location.pathname.includes("manuell");

  const steps: StepId[] = [
    mode === "behandler" && integrationType !== "2" && "POWER_OF_ATTOURNEY",
    (isManualRegistration || !chosenOrgRegisteredInDigipost) && "TERMS",
    isManualRegistration && "MANUAL_ACCOUNT_DETAILS",
    !chosenOrgRegisteredInDigipost &&
      !isManualRegistration &&
      "ACCOUNT_DETAILS",
    "COMPLETE",
  ].filter((id: string | false): id is StepId => !!id);

  const getLabel = (stepId: StepId): string => {
    switch (stepId) {
      case "POWER_OF_ATTOURNEY":
        return translate("stepper.power_of_attourney");
      case "TERMS":
        return translate("stepper.terms");
      case "MANUAL_ACCOUNT_DETAILS":
        return translate("stepper.account_details");
      case "ACCOUNT_DETAILS":
        return translate("stepper.account_details");
      case "COMPLETE":
        return translate("stepper.complete");
    }
  };

  return (
    <Stepper
      activeStep={steps.indexOf(currentStep) + 1}
      onStepChange={noop}
      className={styles.stepper}
      data-testid="register-flow-stepper"
    >
      {steps.map((step, index) => (
        <Stepper.Step
          key={step}
          title={getLabel(step)}
          stepNumber={index + 1}
          as="div"
        />
      ))}
    </Stepper>
  );
};

export default RegisterFlowStepper;
